var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function ProductTypePicker(el) {
  this.el = el;
  this.$el = $(el);
  this.eventX;
  this.isDragging = false;

  this.$el.on('mousedown', this.mouseDragStart.bind(this));

  $(window)
    .on('mousemove', this.mouseDragMove.bind(this))
    .on('mouseup', this.mouseDragEnd.bind(this))

  this.$el.on('click', '.product-type-tab', function(event) {
    var $target = $(event.target).closest('.product-type-tab');

    gtmTrackEvent({
      'event': 'product-select',
      'selected-product': $.trim($target.text())
    });

    this.scrollToTab($target);
    this.scrollToSection();
  }.bind(this));

  this.$el.find('.product-type-tab[data-active]').trigger('click');
}

ProductTypePicker.prototype = {
  mouseDragStart: function(event) {
    event.preventDefault();

    this.$el.one('mousemove', function() {
      this.isDragging = true;
    }.bind(this))

    this.eventX = event.clientX;

    this.$el.addClass('dragging');
  },
  mouseDragMove: function(event) {
    if(this.isDragging) {
      this.el.scrollLeft -= (this.eventX * -1) + event.clientX;

      this.eventX = event.clientX;
    }
  },
  mouseDragEnd: function(event) {
    this.isDragging = false;
    this.$el.removeClass('dragging').off('mousemove');
  },
  scrollToTab: function($t) {
    var currentLeft = this.$el.scrollLeft();
    var destinationLeft = ($t.offset().left + currentLeft - this.$el.offset().left) - (this.$el.outerWidth() / 2) + ($t.outerWidth() / 2);

    if(Modernizr.scrollbehavior) {
      this.$el.scrollLeft(destinationLeft);
    } else {
      this.$el.animate({
        scrollLeft: destinationLeft
      }, 200);
    }
  },
  scrollToSection: function() {
    var $section = this.$el.closest('section');
    var scrollDest = $section.offset().top + 1;


    if($section.is('.product-listing, .home-products-slider')) {
      scrollDest -= $('.header-bar').outerHeight();
      scrollDest += 50;
    }

    if($section.is('.home-products-slider')){
      scrollDest += $('.home-products-slider h2').outerHeight();
    }

    if($section.is('.product-listing')){
      scrollDest += $('.product-types h2').outerHeight();
    }

    if($('html').hasClass('css-parallax')) {
      var $scrollContainer = $('main');
      scrollDest += $scrollContainer.scrollTop();
      if(!$section.is('.home-products-slider, .product-listing')){
        var shouldScroll = ($scrollContainer.scrollTop() < scrollDest);
      }else{
        var shouldScroll = true;
      }
    } else {
      var $scrollContainer = $('html, body');
      var shouldScroll = ($(window).scrollTop() < scrollDest);
    }

    if(shouldScroll) {
      $scrollContainer.animate({
        'scrollTop': scrollDest
      }, 600);
    }
  }
}

module.exports = ProductTypePicker;